<template>
  <div class="order-detail">
    <div class="card-item borrow">
      <h3 class="title">
        <span>{{info.productName}}</span>
        <router-link :to="`/user/order/${orderNo}/repaymentplan`" v-if="info.isRP"  class="repaymentplan">还款计划</router-link>
      </h3>
      <p class="sign-date" v-if="info.signDate">
        <span class="label">签约日期：</span><span class="value">{{info.signDate}}</span>
      </p>
      <p class="is-bind-card" v-if="info.hasAutho == 1">
        <span>·已綁定还款卡</span>
      </p>
      <p class="money" v-if="info.borrowMoney">
        <span class="label">借款金额：</span>
        <span class="value">{{info.borrowMoney}}元</span>
      </p>
      <div class="clearfix">
        <p class="rate half" v-if="info.interestRate">
          <span class="label">借款月利率：</span>
          <span class="value">{{info.interestRate}}%</span>
        </p>
        <p class="money half" v-if="info.interest">
          <span class="label">借款利息：</span>
          <span class="value">{{info.interest}}元</span>
        </p>
      </div>
      <p class="duration" v-if="info.duration"><span class="label">借款期限：</span><span class="value">{{info.duration}}{{info.unit}}</span></p>
      <p class="money" v-if="info.loanMoney"><span class="label">贷款金额：</span><span class="value">{{info.loanMoney}}元</span></p>
      <p class="bank" v-if="info.loanBank"><span class="label">申贷银行：</span><span class="value">{{info.loanBank}}</span></p>
      <p class="num" v-if="info.loanCardNo"><span class="label">放款卡号：</span><span class="value">{{info.loanCardNo}}</span></p>
      <p class="name" v-if="info.loanCardName"><span class="label">放款卡户名：</span><span class="value">{{info.loanCardName}}</span></p>
      <p class="bank" v-if="info.loanCardBank"><span class="label">放款卡开户行：</span><span class="value">{{info.loanCardBank}}</span></p>
      <p class="date" v-if="info.loanDate"><span class="label">放款日期：</span><span class="value">{{info.loanDate}}</span></p>
      <p class="date" v-if="info.startRepaymentTime"><span class="label">预计还款时间：</span><span class="value">{{info.startRepaymentTime}}</span></p>
      <p class="date" v-if="info.successRepaymentTime"><span class="label">实际还款时间：</span><span class="value">{{info.successRepaymentTime}}</span></p>
      <p class="pro" v-if="info.housePro"><span class="label">房屋属性：</span><span class="value">{{info.housePro}}</span></p>
      <p class="addr" v-if="info.houseAddr"><span class="label">房屋地址：</span><span class="value">{{info.houseAddr}}</span></p>
      <div class="btn-group">
        <button v-if="isFI" type="button" class="btn btn-action" @click="isPerfectInfo = true">完善借款信息</button>
        <router-link v-if="info.isAutho" :to="`/user/order/${orderNo}/authorization`" class="btn btn-action">{{info.authoName}}</router-link>
      </div>
    </div>
    <spinner :show="loading"></spinner>
    <div class="perfectInfoConfirm" v-show="isPerfectInfo">
      <div class="modal-backdrop"></div>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="dialog-bd">
            <div class="dialog-msg-container">{{info.productName}}需要获取您的手机通讯录，请通过融资专家APP提交您的手机通讯录信息。</div>
          </div>
          <div class="dialog-ft">
            <a href="javascript:;" class="dialog-btn default" @click="onCancel">取消</a>
            <a href="javascript:;" class="dialog-btn primary" @click="onConfirm">下载融资专家APP</a>
            <!-- <a href="/images/myw3schoolimage.jpg" download="w3logo"> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Scroller from 'components/scroller/scroller'
  import Spinner from 'components/spinner/spinner'

  export default {
    data () {
      return {
        loading: false,
        info: {},
        isPerfectInfo: false,
        isFI: 0,
        orderNo: ''
      }
    },
    components: {
      Navbar,
      Scroller,
      Spinner
    },
    mounted () {
      this.token = this.$cache.getUserToken()
      this.orderNo = this.$route.params.orderNo
      this.isFI = Number(this.$route.query.isFI) || 0
      this._fetchData()
    },
    methods: {
      onConfirm () {
        this.isPerfectInfo = false
        window.location.href = 'http://image.91weijia.com/91weijia/app/zapp-wap/index.html'
      },
      onCancel () {
        this.isPerfectInfo = false
      },
      _fetchData () {
        let vm = this
        this.loading = true
        this.$ajax({
          url: '/center/getOrderInfo.jhtml',
          params: {
            no: vm.orderNo,
            uid: vm.token.uid
          },
          done (info) {
            vm.info = info
          },
          fail (msg) {
            vm.$dialog(msg)
          },
          always () {
            vm.loading = false
          }
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'
  .order-detail
    overflow auto
    height 100%
  .card-item
    position relative
    // margin px2rem(20)
    padding px2rem(40) px2rem(26)
    font-size px2rem(26)
    // background-color #fff
    border-radius px2rem(5)
    // box-shadow 0 px2rem(10) px2rem(15) rgba(171,185,197, 1)
    // min-height 100%
  .borrow
    .title
      margin 0
      font-size px2rem(34px)
      font-weight bold
      height 22px
      color rgb(39, 84, 130)
      .repaymentplan
        float right
        height 22px
        padding 0 10px
        line-height 20px
        font-size 15px
        font-weight normal
        border 1px solid rgba(39,84,130,1)
        border-radius 64px
        color #275482
    p
      margin 0
      color rgb(78, 70, 90)
      padding px2rem(20px) 0
      line-height px2rem(38px)
      display flex
      &.sign-date
        color rgb(18, 170, 235)
      &.is-bind-card
        color #60c9c8
      &.half
        float left
        width 50%
      span.value
        color rgb(51, 51, 51)
        flex 1
  .btn-group
    margin px2rem(20)
    padding px2rem(20px) 0
    font-size 0
    .btn
      display block
      height px2rem(80px)
      line-height px2rem(80px)
      font-size px2rem(32px)
      border none
      border-radius px2rem(8px)
      letter-spacing px2rem(4)
      &.btn-action
        width 85%
        text-align center
        color #fff
        margin 0 auto 20px
        background-color #60c9c8
        box-shadow 0 0 px2rem(4px) rgba(18,119,163, .75)
  .perfectInfoConfirm
    .modal-backdrop,
    .modal-dialog
      position fixed
      top 0
      left 0
      width 100%
      height 100%
    .modal-backdrop
      z-index 1000
      background-color rgba(#000, 15%)
      overflow hidden
    .modal-dialog
      z-index 1080
    .modal-content
      position absolute
      top 50%
      left 50%
      width 80%
      background-color #fff
      border-radius 5px
      transform translate(-50%, -50%)
      -webkit-transform translate(-50%, -50%)
      box-shadow 0 0 10px rgba(#abb9c5, .75)
    .dialog-hd
      padding 0 px2rem(30px)
      text-align center
      white-space nowrap
      text-overflow ellipsis
      overflow hidden
      border-top-left-radius 5px
      border-top-right-radius 5px
      .dialog-title
        margin 0
        padding 0
        font-size px2rem(28px)
        line-height px2rem(80px)
    .dialog-bd
      padding px2rem(20px) px2rem(30px)
      font-size px2rem(28px)
      text-align center
      line-height 2
      .form-control
        display block
        padding 6px 15px
        width 100%
        line-height 1
        border 1px solid #60c9c8
        border-radius 5px
        box-sizing border-box
    .dialog-ft
      display table
      width 100%
      padding 0
      setTopLine(#ddd)
      .dialog-btn
        display table-cell
        font-size px2rem(28px)
        line-height px2rem(80px)
        text-align center
        border none
        width 50%
        &:first-child
          border-bottom-left-radius 5px
        &:last-child
          border-bottom-right-radius 5px
        &.default
          color #21507f
          background-color transparent
        &.primary
          color #fff
          background-color #60c9c8
</style>



// WEBPACK FOOTER //
// order-detail.vue?00fe3673